/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGridViewLarge = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 13v9H2v-9zm11 0v9h-9v-9zM9 15H4v5h5zm11 0h-5v5h5zM11 2v9H2V2zm11 0v9h-9V2zM9 4H4v5h5zm11 0h-5v5h5z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGridViewLarge as GridViewLarge };
